import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormService } from '../../../app/parkifly-bookings/organizations/features/booking/components/form/service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DateTimeFlightPickerComponent } from '../../../app/parkifly-bookings/datetimeflight-picker/datetimeflight-picker.component';
import { CommonModule, DatePipe } from '@angular/common';
import { RouteParamService } from '../../../app/parkifly-bookings/services/route-param.service';
import { SimpleSearchSelectComponent } from '../../../app/parkifly-bookings/components/simple-search-select/simple-search-select.component';
import { format } from 'date-fns';
import { FormControl } from '@angular/forms';
import { TextInputDataComponent } from '../../../app/parkifly-bookings/components/text-input/text-input.component';
import { BookingConfigService } from '../../../app/parkifly-bookings/services/booking-config.service';
import { TopNavbarComponent } from '../../../app/parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { SelfServiceService } from '../../../app/services/self-service.service';
import { WelcomeComponent } from '../../../app/parkifly-bookings/components/welcome/welcome.component';
import { AuthService } from '../../../app/services/auth.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MaintenanceService } from '../../../app/services/maintenance.service';
import { LoginService } from '../../../app/services/login.service';

@Component({
  selector: 'app-parking-permit',
  imports: [
    CommonModule,
    TranslocoModule,
    DateTimeFlightPickerComponent,
    SimpleSearchSelectComponent,
    TextInputDataComponent,
    TopNavbarComponent,
    WelcomeComponent
  ],
  templateUrl: './parking-permit.component.html',
  styleUrl: './parking-permit.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService, DatePipe]
})
export class ParkingPermitComponent {

  site: string = '';
  parkingStartTime: any;
  parkingEndTime: any;
  selectType: string = '';
  searchData: any;
  routerState: any;
  discountCodeControl: FormControl = new FormControl('');
  isLoggedIn: boolean = false;
  // parkingOperators: any[] = [];
  orgId: any = '';
  showToggle: any = false;
  isContinueButtonEnabled: boolean = false;

  constructor(
    private router: Router,
    private _formService: FormService,
    private _datePipe: DatePipe,
    private route: ActivatedRoute,
    private routeParamService: RouteParamService,
    private _router: Router,
    private bookingConfigService: BookingConfigService,
    private selfServiceService: SelfServiceService,
    public authService: AuthService,
    private dialog: MatDialog,
    private maintenanceService: MaintenanceService,
    private loginService: LoginService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = "skavsta";
    this.orgId = "DC3E5C36-A4F7-4886-98F2-4833EA27F84B";
    this.bookingConfigService.setOrganization(this.site);

    this._formService.initForm(this.site);
    const routerState = this._router.getCurrentNavigation();

    sessionStorage.removeItem('isQuality2daysBooking');
    sessionStorage.removeItem('isAiden2daysBooking');
    sessionStorage.removeItem('showSubscription');
    sessionStorage.removeItem('isFromCustomerHome');
    sessionStorage.removeItem('selectedParkingFromSearch');

    if (routerState?.extras) {
      this.searchData = routerState?.extras?.state ?? null;

      if (this.searchData) {
        this.parkingStartTime = this.searchData.departureDate;
        this.parkingEndTime = this.searchData.arrivalDate;
        this.discountCodeControl.setValue(this.searchData?.discountCode);
      }
    }

  }

  ngOnInit(): void {
    if (this.router.url === '/parking-permit') {
      sessionStorage.setItem('isParkingPermitUser', 'true');
    }
    this.updateContinueButtonState();
    this.checkMaintenanceTime();

    const search = this._formService.getForm().get('search');

    search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
      this.parkingEndTime = value;
    })
    search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
      this.parkingStartTime = value;
      this.updateContinueButtonState();
    })

  }

  updateContinueButtonState() {
    const isParkingPermitUser = sessionStorage.getItem('isParkingPermitUser') === 'true';
    if (isParkingPermitUser) {
      const date = new Date(this.parkingStartTime);
      this.parkingEndTime = new Date(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      this.isContinueButtonEnabled = this.parkingStartTime != null;
    } else {
      this.isContinueButtonEnabled = false;
    }
  }

  goToBookingForm() {
    if (this.authService.loggedIn()) {
      this.navigateToBooking();
    } else {
      if (this.loginService.showPopupValue === false) {
        this.navigateToBooking();
      }
      else {
        const dialogRef = this.dialog.open(WelcomeComponent, {
          width: '500px',
          disableClose: false,
          panelClass: 'welcome-dialog'
        });

        dialogRef.afterClosed().subscribe(() => {
          this.navigateToBooking();
        });
      }
    }
  }

  navigateToBooking() {
    const search = this._formService.getForm().get('search');
    let parking_start = format(this.parkingStartTime, 'yyyy-MM-dd HH:mm')
    let parking_end = format(this.parkingEndTime, 'yyyy-MM-dd HH:mm')
    let queryParams: any = {
      parking_start: parking_start || undefined,
      parking_end: parking_end || undefined,
    };
    if (this.discountCodeControl.value.length) {
      queryParams['discount_code'] = this.discountCodeControl.value;
    }
    this.router.navigate(['parkifly', this.site, 'booking', queryParams]);
  }

  checkMaintenanceTime() {
    this.maintenanceService.checkMaintenanceTime();
  }

  // loadParkingOperators() {
  //   this.selfServiceService.getParkingOperators('SWE').then((result) => {
  //     this.parkingOperators = result?.stations || [];
  //     const subscriptionExists = this.parkingOperators.some(station =>
  //       station.parkingOperators?.some(op => op.organizationId?.toLowerCase() == this.orgId?.toLowerCase() && op.subscriptionParking == true)
  //     );
  //     this.showToggle = subscriptionExists && this.isLoggedIn;
  //   });
  // }

}

@Component({
  selector: 'app-maintenance-dialog',
  imports: [TranslocoModule],
  template: `
    <div class="maintenance-dialog">
    <div class="flex justify-center py-4">
        <svg width="106" height="117" viewBox="0 0 106 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M74.0049 23.325L58.7525 11.805C55.3515 9.23619 50.6589 9.2362 47.2578 11.805L32.0055 23.325L13.8482 29.8366C9.49901 31.3963 6.89367 35.8495 7.6651 40.405L10.6508 58.0367L7.6651 75.6684C6.89366 80.2239 9.49902 84.6771 13.8482 86.2368L32.0055 92.7484L47.2578 104.268C50.6589 106.837 55.3515 106.837 58.7525 104.268L74.0049 92.7484L92.1622 86.2368C96.5114 84.6771 99.1167 80.2239 98.3453 75.6684L95.3595 58.0367L98.3453 40.405C99.1167 35.8495 96.5114 31.3963 92.1622 29.8366L74.0049 23.325Z"
                fill="#FFEDE3" stroke="#FFF5F5" stroke-width="13.6229" />
            <circle cx="52" cy="57" r="10" stroke="#DC0032" stroke-width="2" fill="#FFEDEE" />
            <line x1="47" y1="52" x2="57" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />
            <line x1="57" y1="52" x2="47" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />

        </svg>
    </div>
      <h2>{{ 'MAINTENANCE.TITLE' | transloco }}</h2>
      <p>{{ 'MAINTENANCE.MESSAGE' | transloco }} {{ data?.endTime }}.</p>
      <div class="language-toggle">
            <div>
            <button class="
            w-[48px]
            h-[48px]
            " (click)="toggleLanguage()" style="outline: none;">
                <img src="{{languageImageSource}}" alt="toggle language" class="w-[25px] h-[25px]">
            </button>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .maintenance-dialog {
      padding: 24px;
      text-align: center;
      position: relative;
    }
    h2 {
      margin-bottom: 16px;
      color: #f44336;
    }
  `]
})
export class MaintenanceDialogComponent {
  currentLang = 'sv';

  languageImageSources: { [key: string]: string } = {
    en: "../../../../../assets/img/flag-button-round-250-EN.png",
    sv: "../../../../../assets/img/flag-button-round-250-SV.png",
  };

  languageImageSource: string = '';

  constructor(private _translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: { endTime: string }
  ) {
    this.currentLang = this._translocoService.getActiveLang();
    this.languageImageSource = this.currentLang === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }

  toggleLanguage() {

    let activeLanguage = this._translocoService.getActiveLang();

    if (activeLanguage == 'sv') {
      this._translocoService.setActiveLang('en');
    } else {
      this._translocoService.setActiveLang('sv');
    }

    activeLanguage = this._translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];

  }
}